/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export interface TravelTicker {
  message: string;
  type: TravelTicker_Type;
}

export enum TravelTicker_Type {
  TypeUnknown = "TypeUnknown",
  Positive = "Positive",
  Negative = "Negative",
  Warning = "Warning",
}

export function travelTicker_TypeFromJSON(object: any): TravelTicker_Type {
  switch (object) {
    case 0:
    case "TypeUnknown":
      return TravelTicker_Type.TypeUnknown;
    case 1:
    case "Positive":
      return TravelTicker_Type.Positive;
    case 2:
    case "Negative":
      return TravelTicker_Type.Negative;
    case 3:
    case "Warning":
      return TravelTicker_Type.Warning;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum TravelTicker_Type"
      );
  }
}

export function travelTicker_TypeToJSON(object: TravelTicker_Type): string {
  switch (object) {
    case TravelTicker_Type.TypeUnknown:
      return "TypeUnknown";
    case TravelTicker_Type.Positive:
      return "Positive";
    case TravelTicker_Type.Negative:
      return "Negative";
    case TravelTicker_Type.Warning:
      return "Warning";
    default:
      return "UNKNOWN";
  }
}

export function travelTicker_TypeToNumber(object: TravelTicker_Type): number {
  switch (object) {
    case TravelTicker_Type.TypeUnknown:
      return 0;
    case TravelTicker_Type.Positive:
      return 1;
    case TravelTicker_Type.Negative:
      return 2;
    case TravelTicker_Type.Warning:
      return 3;
    default:
      return 0;
  }
}

export interface TravelTickerList {
  items: TravelTicker[];
}

function createBaseTravelTicker(): TravelTicker {
  return { message: "", type: TravelTicker_Type.TypeUnknown };
}

export const TravelTicker = {
  encode(
    message: TravelTicker,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    if (message.type !== TravelTicker_Type.TypeUnknown) {
      writer.uint32(16).int32(travelTicker_TypeToNumber(message.type));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TravelTicker {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTravelTicker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.message = reader.string();
          break;
        case 2:
          message.type = travelTicker_TypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TravelTicker {
    return {
      message: isSet(object.message) ? String(object.message) : "",
      type: isSet(object.type)
        ? travelTicker_TypeFromJSON(object.type)
        : TravelTicker_Type.TypeUnknown,
    };
  },

  toJSON(message: TravelTicker): unknown {
    const obj: any = {};
    message.message !== undefined && (obj.message = message.message);
    message.type !== undefined &&
      (obj.type = travelTicker_TypeToJSON(message.type));
    return obj;
  },

  fromPartial(object: DeepPartial<TravelTicker>): TravelTicker {
    const message = createBaseTravelTicker();
    message.message = object.message ?? "";
    message.type = object.type ?? TravelTicker_Type.TypeUnknown;
    return message;
  },
};

function createBaseTravelTickerList(): TravelTickerList {
  return { items: [] };
}

export const TravelTickerList = {
  encode(
    message: TravelTickerList,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    for (const v of message.items) {
      TravelTicker.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TravelTickerList {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTravelTickerList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.items.push(TravelTicker.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TravelTickerList {
    return {
      items: Array.isArray(object?.items)
        ? object.items.map((e: any) => TravelTicker.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TravelTickerList): unknown {
    const obj: any = {};
    if (message.items) {
      obj.items = message.items.map((e) =>
        e ? TravelTicker.toJSON(e) : undefined
      );
    } else {
      obj.items = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<TravelTickerList>): TravelTickerList {
    const message = createBaseTravelTickerList();
    message.items = object.items?.map((e) => TravelTicker.fromPartial(e)) || [];
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
